import { doc, collection, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../config/firebase-config";
import { useGetUserInfo } from "./useGetUserInfo";

export const useAddHabit = () => {
    const { userID } = useGetUserInfo();

    const addHabit = async ({ habitName }) => {
        try {
            // Create a new document reference with an auto-generated ID
            const habitDocRef = doc(collection(db, "users", userID, "habits"));

            // Add the habit to Firestore with the generated ID
            await setDoc(habitDocRef, {
                habitName,
                completedDates: {},
                createdAt: serverTimestamp()
            });

            console.log(`Habit "${habitName}" added successfully.`);
        } catch (error) {
            console.error("Error adding habit:", error);
            throw error; // Re-throw error to handle in the component
        }
    };

    return { addHabit };
};